import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const bulkReadDeleteNotification = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.NOTIFICATION.BULK_READ_DELETE,
      method: 'put',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
